const transformPhoneNum = (phoneNumStr) => {
  let numOnly = phoneNumStr.replace(/\D/g,'');
  if (numOnly.length > 10) {
    let removeInt = numOnly.length - 10;
    numOnly = numOnly.slice(removeInt);
  }
  
  if (numOnly.length == 10) {
    //reformat and return phone number
    return numOnly.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }

  return phoneNumStr;
};

export default transformPhoneNum;
